import { getDefaultParameters } from "@/utils/getDefaultParameters";
import axios, { type AxiosInstance } from "axios";
import { type BaseResponse } from "../types";

const baseUrl = process.env.REACT_APP_BACKEND_URL;
const instanceConfig = {
    baseURL: baseUrl,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: false,
    timeout: 5000,
};

const axiosInstance: AxiosInstance = axios.create(instanceConfig);

export const api = {
    get: <T>(url: string, params?: Record<string, unknown>) => {
        const defaultParams = getDefaultParameters();
        const mergedParams = { ...defaultParams, ...params };

        const searchParams = new URLSearchParams(mergedParams);
        const urlWithParams = `${url}?${searchParams?.toString()}`;

        return axiosInstance.get<BaseResponse<T>>(urlWithParams);
    },
    post: <T>(...args: Parameters<typeof axiosInstance.post>) => {
        return axiosInstance.post<BaseResponse<T>>(...args);
    },
    put: <T>(...args: Parameters<typeof axiosInstance.put>) => {
        return axiosInstance.put<BaseResponse<T>>(...args);
    },
    patch: <T>(...args: Parameters<typeof axiosInstance.patch>) => {
        return axiosInstance.patch<BaseResponse<T>>(...args);
    },
    delete: <T>(...args: Parameters<typeof axiosInstance.delete>) => {
        return axiosInstance.delete<BaseResponse<T>>(...args);
    },
};
